/* eslint-disable @stylistic/comma-dangle */

import { sharedLocale }	from "@geotoura/shared/sharedLocale_en";
import { siteInfo }		from "@geotoura/shared/siteInfo_en";
import { Title }		from "@geotoura/shared/commonModel";

export const messages = {
	form: {
		fieldRequired:		"This field is mandatory.",
		fieldInvalid:		"The value of this field is invalid.",
		privacyAgreement:	sharedLocale.privacyAgreement,
		title: {
			label:	"Title",
			choices: [
				Title.brand("Dr."),
				Title.brand("Mag."),
				Title.brand("Prof."),
			],
		},
		gender:		{
			label: 		"Gender",
			choices:	{
				u:	"",
				m:	"male",
				w:	"female",
				d:	"diverse"
			},
		},
		firstName:	"First name",
		lastName:	"Last name",
		email: {
			label:			"E-Mail",
			placeholder:	"Your e-mail address",
		},
		phone: {
			label:			"Telephone",
			placeholder:	"Your telephone number",
		},
	},
	privacy: {
		title:	"Cookie settings",
		intro: {
			pre:	"In addition to the cookies that are technically necessary, we use cookies to analyse the use of our website. Under statistics and marketing, we and our partner carry out the following data processing activities: personalized advertising and content, measurement and performance of ads and content, as well as storing or accessing information on a device through technical cookies. You can object to the use of cookies here or via our ",
			link: {
				href:	siteInfo.page.privacy,
				text:	"privacy page"
			},
			post:	"at any time."
		},
		essential:	"Technically necessary",
		nonessential: {
			pre:	"Statistics and marketing (",
			link: {
				href:	siteInfo.page.privacy,
				text:	"further information"
			},
			post:	")",
		},
		saveSettings:	"Save settings",
		acceptAll:		"Accept all",
		imprint: {
			pre:	"",
			link: {
				href:	siteInfo.page.impressum,
				text:	"Legal notice"
			},
			post:	"",
		},
	},
};
